import React from 'react';
import styles from './onThisDayStyles';

const EventCard = ({ data, type }) => {
  const getSportEmoji = (sport) => {
    const emojis = {
      football: '⚽',
      tennis: '🎾',
      cricket: '🏏',
      basketball: '🏀',
      baseball: '⚾',
      golf: '⛳',
      rugby: '🏉',
      hockey: '🏒',
      other: '🏅'
    };
    return emojis[sport] || '🏆';
  };

  const getTypeIcon = () => {
    if (type === 'births') return '🎂';
    if (type === 'deaths') return '🕊️';
    return '🏆';
  };

  return (
    <div style={styles.eventCard} className="event-card-responsive">
      <div style={styles.eventLeft} className="event-left-responsive">
        <div style={styles.sportBadge} className="sport-badge-responsive">
          {getSportEmoji(data.sport)}
        </div>
        <div style={styles.yearBadge} className="year-badge-responsive">{data.year}</div>
      </div>
      
      <div style={styles.eventCenter} className="event-center-responsive">
        <div style={styles.eventIcon} className="event-icon-responsive">{getTypeIcon()}</div>
        <div style={styles.eventContent}>
          <p style={styles.eventText} className="event-text-responsive">{data.text}</p>
          {data.pages && data.pages.length > 0 && (
            <div style={styles.relatedLinks}>
              {data.pages.slice(0, 2).map((page, idx) => (
                <a
                  key={idx}
                  href={`https://en.wikipedia.org/wiki/${page.title}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.link}
                  className="link-responsive"
                >
                  📖 {page.title}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
